import { ModalType } from '../interfaces/modal-types.enum';
import { useModalStore } from '../stores/modal-store';
import { useUserStore } from '../stores/user-store';

// Port of src/app/services/affiliation-timer.service.ts (singleton timer
// module). Opens the AFFILIATION_LINK modal once 15 minutes (tracked across
// reloads via localStorage 'startTime') have elapsed for a logged-in user who
// hasn't opted out via the 'dontShowAffiliationAgain' preference.

const startTimeKey = 'startTime';
const durationInMinutes = 15;
let intervalId: ReturnType<typeof setInterval> | undefined;
let isTimerRunning = false; // Flag to track if the timer is running

export function startAffiliationTimer(): void {
  const user = useUserStore.getState().user;
  if (user && user.preferences['dontShowAffiliationAgain'] === 'true') {
    stopAffiliationTimer();
    return;
  }
  // Check if the timer is already running
  if (isTimerRunning) {
    return; // If running, just return and do nothing
  }

  // Mark the timer as running
  isTimerRunning = true;

  // Check if startTime is stored in localStorage; if not, initialize it
  const startTime = localStorage.getItem(startTimeKey);
  if (!startTime) {
    localStorage.setItem(startTimeKey, Date.now().toString());
  }

  // Start the interval to check the time
  checkTime();
  intervalId = setInterval(() => checkTime(), 1000);
}

export function stopAffiliationTimer(): void {
  if (intervalId) {
    clearInterval(intervalId);
    isTimerRunning = false; // Mark the timer as not running
  }
}

function checkTime(): void {
  const startTime = localStorage.getItem(startTimeKey);
  if (startTime) {
    const elapsedTime = (Date.now() - Number(startTime)) / 1000 / 60; // in minutes
    if (elapsedTime >= durationInMinutes) {
      const user = useUserStore.getState().user;
      if (user) {
        if (user.preferences['dontShowAffiliationAgain'] === 'true') {
          stopAffiliationTimer();
        } else {
          useModalStore.getState().open(ModalType.AFFILIATION_LINK);
        }
      }
      localStorage.setItem(startTimeKey, Date.now().toString()); // Reset the timer
    }
  }
}
